import React from 'react';

import style from './index.module.scss';
import ServerErrorImg from '../../../assets/images/ServerError.png';

const NotFound = () => (
  <div className={style.serverError}>
    <img src={ServerErrorImg} alt="Ничего не найдено" />
    <h2 className={style.description}>
      Нет ответа от сервера <br /> Попробуйте позднее
    </h2>
  </div>
);

export default NotFound;
